var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative flex-auto py-4 bg-gray-400 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent"},[_c(_vm.componentName,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }